import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initI18n } from "@/i18n";
import { captureInstallPrompt } from "@/lib/install";
import { installItalianValidation } from "@/lib/validity";

captureInstallPrompt();
installItalianValidation();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

initI18n().finally(() => {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
});

if ("serviceWorker" in navigator) {
  // Alla prima installazione non ricarica (cancellerebbe ciò che si sta scrivendo, es. il login);
  // con un aggiornamento aspetta che non si stia scrivendo in un campo.
  const hadController = !!navigator.serviceWorker.controller;
  let refreshing = false;
  const reload = () => { if (!refreshing) { refreshing = true; window.location.reload(); } };
  const typing = () => ["INPUT", "TEXTAREA", "SELECT"].includes(document.activeElement?.tagName);
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hadController) return;
    if (!typing()) return reload();
    document.addEventListener("visibilitychange", () => { if (document.hidden) reload(); }, { once: true });
  });
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        reg.update().catch(() => {});
        setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
      })
      .catch(() => {});
  });
}
